import React, {useEffect, useState} from 'react';
import {useToast} from "../../../../../../utils/contexts/toast-context";
import {CustomAxiosError} from "../../../../../../logics/api_config";
import Loading from "../../../../../ui/Loading";
import {useTranslation} from "react-i18next";
import {IDocCompanyDocReason} from "../../../../../../utils/interfaces/my_documents/doc_reason/IDocCompanyDocReason";
import useApiGetCompanyDocReasons from "./api-hooks/useApiGetCompanyDocReasons";
import {Box, TextField} from "@mui/material";
import MuiAutocomplete from "../../../../../ui/mui/mui-input/MuiAutoComplete";
import useApiGetCompanyDocReason from "./api-hooks/useApiGetCompanyDocReason";


interface Props {
    doc_reason: IDocCompanyDocReason | undefined,
    onChange: (doc_reason: IDocCompanyDocReason | undefined) => void,
    className: string,
    label?: string,
    clearable?: boolean
    required?: boolean,
}

const DocReasonSelect = ({doc_reason: initialObj, onChange, label, required, clearable, ...props}: Props) => {
    const {displayError} = useToast()
    const {t} = useTranslation();
    const {className = ''} = props;
    const [objs, setObjs] = useState<IDocCompanyDocReason[]>([]);
    const [obj, setObj] = useState<IDocCompanyDocReason>()

    const {
        data,
        isLoading,
        error,
    } = useApiGetCompanyDocReasons();
    if (error) {
        const axiosError = error as CustomAxiosError;
        displayError(axiosError.response.data.detail);
    }

    useEffect(() => {
        if (initialObj) {
            setObj(initialObj)
        }
    }, [initialObj]);

    useEffect(() => {
        if (data) {
            setObjs(data);
        }
    }, [data]);

    const {
        data: detailedObj,
    } = useApiGetCompanyDocReason(obj?.id);


    useEffect(() => {
        onChange(obj);
    }, [obj]);

    const handleOnChange = (event: React.SyntheticEvent, newValue: IDocCompanyDocReason | null) => {
        if (newValue) {
            onChange(newValue);
        } else {
            onChange(undefined);
        }

    };

    return (
        <>
            {isLoading ? (
                <Loading/>
            ) : (
                <>
                    <Box sx={{alignItems: 'center', width: '100%'}}>
                        <MuiAutocomplete
                            id="curreny-select"
                            options={objs}
                            getOptionLabel={(option) => option.doc_reason.name + ' - ' + option.doc_reason.extended_name}
                            value={detailedObj ? detailedObj : null}
                            onChange={handleOnChange}
                            isOptionEqualToValue={(option, value) => option.id === value?.id && option.doc_reason.name === value?.doc_reason.name}
                            renderInput={(params) => (
                                <TextField
                                    sx={{textTransform: 'capitalize'}}
                                    {...params}
                                    label={t(label ? label : '') || t('currency')}
                                    required={required}
                                />
                            )}
                        />
                    </Box>

                </>
            )}
        </>
    );
}

export default DocReasonSelect;